import * as z from "zod";
import { OC } from "../../utils";
import { AdminClient } from "./schema";

export const clientContract = OC.router({
  get: OC.meta({ permissions: ["client:get"] })
    .input(AdminClient.Get)
    .output(AdminClient.Client),
  getAll: OC.meta({ permissions: ["client:get"] })
    .input(AdminClient.GetAll)
    .output(
      z.array(
        AdminClient.Client.omit({
          nIdFrontIv: true,
          nIdBackIv: true,
          nIdFrontKey: true,
          nIdBackKey: true,
          encryptionKey: true,
        }).extend({
          number: z.number(),
        }),
      ),
    ),
  count: OC.meta({ permissions: ["client:get"] })
    .input(
      AdminClient.GetAll.omit({
        page: true,
        limit: true,
        sortBy: true,
        sortOrder: true,
      }),
    )
    .output(z.number()),
  create: OC.meta({
    alters: true,
    permissions: ["client:create"],
    auditLog: { modelName: "CLIENT", action: "CREATE" },
    aragon: "client_created",
  })
    .input(AdminClient.Create)
    .output(
      AdminClient.Client.omit({
        totalAmountDue: true,
        lastTripDate: true,
        totalBookings: true,
        totalSpent: true,

        nIdFrontIv: true,
        nIdBackIv: true,
        nIdFrontKey: true,
        nIdBackKey: true,
        encryptionKey: true,
      }),
    ),
  update: OC.meta({
    alters: true,
    permissions: ["client:update"],
    auditLog: { modelName: "CLIENT", action: "UPDATE" },
    aragon: "client_updated",
  })
    .input(AdminClient.Update)
    .output(
      AdminClient.Client.omit({
        totalAmountDue: true,
        lastTripDate: true,
        totalBookings: true,
        totalSpent: true,

        nIdFrontIv: true,
        nIdBackIv: true,
        nIdFrontKey: true,
        nIdBackKey: true,
        encryptionKey: true,
      }),
    ),
});
